<template>
  <multiselect
      v-model="selectedItem"
      @update:modelValue="onSelectItem"
      :options="optionsList"
      :placeholder="$t('settings.generic.select-items')"
      label="translationKey" track-by="value"
      class="tracking-multiselect fit-content statuses-select"
      :multiple="multiple"
      :close-on-select="!multiple"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
      :allow-empty="multiple"
  >
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
    <template #option="props">
      <div class="tracking-multiselect-with-checkbox">
        <input
            v-if="multiple"
            type="checkbox"
            :checked="isStatusChecked(props.option.value)"
            @focus.prevent
            :key="props.option.value"
        />
        <span class="option__title">{{ $t(props.option.translationKey) }}</span>
      </div>
    </template>
    <template #beforeList v-if="multiple && this.optionsList.length > 0">
      <li class="multiselect__element" @click="toggleAllStatusesSelection">
        <span class="multiselect__option tracking-multiselect-with-checkbox">
          <input type="checkbox" :checked="areAllStatusesSelected()" @focus.prevent>
          <span class="option__title"><b>{{ $t('settings.generic.select-all') }}</b></span>
        </span>
      </li>
    </template>
    <template #selection="{ values, isOpen }">
      <span class="multiselect__single" v-if="multiple && values.length" v-show="!isOpen">
        {{ $t('settings.generic.selected-items') }} {{ values.length }}
      </span>
    </template>
    <template #singleLabel>
      <span class="option__title pr-5">
        <span class="option__title">
          <span v-if="multiple">
            {{ $t('settings.generic.selected-items') }} {{ selectedItemsCount }}
          </span>
          <span v-else>
            {{ $t(selectedItem.translationKey) }}
          </span>
        </span>
      </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import {MaintenanceStatus} from "@/assets/js/enums/MaintenanceStatus.ts";

export default {
  name: "ChooseMaintenanceStatus",
  components: {Multiselect},
  props: {
    modelValue: {
      type: [Number, Array],
      default() {
        return [];
      }
    },
    addAllOption: {
      type: [Boolean],
      default: false
    },
    multiple: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const maintenanceStatuses = MaintenanceStatus.all();
    if (this.addAllOption) {
      maintenanceStatuses.unshift({value: null, translationKey: 'generic.all'});
    }

    return {
      selectedItem: this.modelValue,
      optionsList: maintenanceStatuses
    };
  },
  mounted() {
    if (this.multiple) {
      this.selectedItem = Array.isArray(this.modelValue) ? this.modelValue : [];
      return;
    }

    if (this.selectedItem || this.addAllOption) {
      const selectedItem = this.optionsList.find(x => x.value === this.selectedItem);
      this.onSelectItem(selectedItem, false);
    }
  },
  watch: {
    modelValue(value) {
      if (this.multiple) {
        this.selectedItem = value || [];
        return;
      }

      this.selectedItem = this.optionsList.find(x => x.value === value);
    }
  },
  computed: {
    selectedItemsCount() {
      return Array.isArray(this.selectedItem) ? this.selectedItem.length : 0;
    }
  },
  methods: {
    onSelectItem(data, triggerValueUpdate = true) {
      this.selectedItem = data;
      if (triggerValueUpdate) {
        const result = this.multiple
            ? (this.selectedItem ?? [])
            : this.selectedItem?.value;
        this.$emit('update:modelValue', result);
      }
    },
    areAllStatusesSelected() {
      if (!this.multiple) {
        return false;
      }

      return (this.selectedItem?.length ?? 0) === this.optionsList.length;
    },
    isStatusChecked(value) {
      if (!this.multiple) {
        return false;
      }

      return (this.selectedItem ?? []).some(x => x?.value === value);
    },
    toggleAllStatusesSelection() {
      if (!this.multiple) {
        return;
      }

      const allSelected = this.areAllStatusesSelected();
      this.onSelectItem(allSelected ? [] : this.optionsList);
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.statuses-select {
  width: 220px;
}

@media (max-width: $breaking-point) {
  .statuses-select {
    width: 100%;
  }
}
</style>
